import { BundleServiceId, BundleServiceIdFVE, BundleServiceIdHeatPump, KETTLE_BRAND } from "@/constants/supplyPoint";
import { BRAND } from "@/constants/supplyPoint";
import { FVEDataFormValues } from "@/screens/SupplyPoint/FVEData/form";
import { HeatPumpDataFormValues } from "@/screens/SupplyPoint/HeatPumpData/form";
import { KettleDataFormValues } from "@/screens/SupplyPoint/KettleData/form";
import { ServiceAttributes, ServiceProducts } from "@/types/enumerations";
import dayjs from "dayjs";

export const bundleServicesKettle = (
  values: KettleDataFormValues,
  serviceAttributes: ServiceAttributes[],
  serviceProducts: ServiceProducts[]
) => {
  const selectedKettle = serviceAttributes
    .filter(service => service.attribute === KETTLE_BRAND)
    .find(findItem => findItem.value === values.kettleBrand);

  const selectedType = serviceProducts
    .filter(service => service.bundleServiceId === BundleServiceId)
    .find(findItem => findItem.id === values.kettleType);

  const kettleBundleServices = [
    {
      bundleServiceId: selectedKettle?.bundleServiceId ?? "",
      serviceAttributeId: KETTLE_BRAND,
      serviceAttributeValue: selectedKettle?.value ?? "",
    },
    {
      bundleServiceId: selectedKettle?.bundleServiceId ?? "",
      serviceAttributeId: "YEAR",
      serviceAttributeValue: `${values.kettleYear}`,
    },
  ];

  if (selectedType) {
    kettleBundleServices.push({
      bundleServiceId: selectedKettle!.bundleServiceId,
      serviceAttributeId: "TYPE",
      serviceAttributeValue: selectedType.value,
    });
  }

  return kettleBundleServices;
};

export const bundleServicesHeatPump = (values: HeatPumpDataFormValues, serviceAttributes: ServiceAttributes[]) => {
  const selectedHeatPump = serviceAttributes
    .filter(service => service.attribute === BRAND)
    .filter(service => service.bundleServiceId === BundleServiceIdHeatPump)
    .find(findItem => findItem.value === values.heatPumpBrand);

  return [
    {
      bundleServiceId: selectedHeatPump?.bundleServiceId ?? "",
      serviceAttributeId: BRAND,
      serviceAttributeValue: selectedHeatPump?.value ?? "",
    },
    {
      bundleServiceId: selectedHeatPump?.bundleServiceId ?? "",
      serviceAttributeId: "DATE",
      serviceAttributeValue: values.heatPumpDate ? dayjs(values.heatPumpDate).format("YYYY-MM-DD") : null,
    },
  ];
};

export const bundleServicesFVE = (values: FVEDataFormValues, serviceAttributes: ServiceAttributes[]) => {
  const selectedFVE = serviceAttributes
    .filter(service => service.attribute === BRAND)
    .filter(service => service.bundleServiceId === BundleServiceIdFVE)
    .find(findItem => findItem.value === values.fveBrand);

  return [
    {
      bundleServiceId: selectedFVE?.bundleServiceId ?? "",
      serviceAttributeId: "INSTALLATION",
      serviceAttributeValue: values.fveInstallation ?? null,
    },
    {
      bundleServiceId: selectedFVE?.bundleServiceId ?? "",
      serviceAttributeId: BRAND,
      serviceAttributeValue: selectedFVE?.value ?? "",
    },
    {
      bundleServiceId: selectedFVE?.bundleServiceId ?? "",
      serviceAttributeId: "NUMBER",
      serviceAttributeValue: values.fveNumber ?? null,
    },
    {
      bundleServiceId: selectedFVE?.bundleServiceId ?? "",
      serviceAttributeId: "DATE",
      serviceAttributeValue: values.fveDate ? dayjs(values.fveDate).format("YYYY-MM-DD") : null,
    },
  ];
};
